var map = {
	"./1.png": 3422,
	"./2.png": 3423,
	"./3.png": 3424,
	"./4.png": 3425
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 676;



//////////////////
// WEBPACK FOOTER
// ./assets/images/ribbons/letters .\.png*
// module id = 676
// module chunks = 0